import React from 'react'
import styles from './RequisitosCard.module.css'

const RequisitosCard = ({ medicos, noMedicos, caso }) => {

    const generarGrupos = (requi, total, tipo) => {
        let listaSalida = []
        let inicio, final
        let mitad = Math.floor(total / 2)

        if (total > (tipo === 'M' ? 3 : 2)) {
            if (total % 2 === 0) {
                inicio = requi.slice(0, mitad)
                final = requi.slice(mitad)
            } else {
                inicio = requi.slice(0, mitad + 1)
                final = requi.slice(mitad + 1)
            }
            listaSalida.push(inicio, final)
        } else {
            listaSalida.push(requi)
        }

        return listaSalida
    }

    return (
        <div className={styles.areadatos}>
            {caso === 1 ?
                <div>
                    <div className={styles.grid_textos}>
                        <div className={styles.gt_text1}>
                            <span>Requisitos médicos</span>
                        </div>
                        <div className={styles.gt_text2}></div>
                        <div className={styles.gt_text3}>
                            <span>Requisitos documentarios</span>
                        </div>
                    </div>
                    <div className={styles.grid_requisitos}>
                        <div className={styles.gr_req1}>
                            <ul>
                                {medicos.map((med, index) => (
                                    <li key={index}>{med}</li>
                                ))}
                            </ul>
                        </div>
                        <div className={styles.gr_req2}></div>
                        <div className={styles.gr_req3}>
                            <ul>
                                {noMedicos.map((med, index) => (
                                    <li key={index}>{med}</li>
                                ))}
                            </ul>
                        </div>
                    </div>
                </div>
                : caso === 2 ?
                    <div className={styles.listado}>
                        <span>Requisitos médicos</span>
                        <br /><br />
                        {generarGrupos(medicos, medicos.length, 'M').map((grupo, index) => (
                            <div key={index} className={styles.grid_medicos}>
                                {grupo.map((med, indexA) => (
                                    <div key={indexA} className={styles['gm_req'.concat(indexA + 1)]}>
                                        <div className={styles.circle}></div>
                                        <div className={styles.descripcion}>{med}</div>
                                    </div>
                                ))}
                            </div>
                        ))}

                    </div>
                    : caso === 3 ?
                        <div className={styles.listado}>
                            <span>Requisitos documentarios</span>
                            <br /><br />
                            {generarGrupos(noMedicos, noMedicos.length, 'NM').map((grupo, index) => (
                                <div key={index} className={styles.grid_nomedicos}>
                                    {grupo.map((med, indexA) => (
                                        <div key={indexA} className={styles['gnm_req'.concat(indexA + 1)]}>
                                            <div className={styles.circle}></div>
                                            <div className={styles.descripcionN}>{med}</div>
                                        </div>
                                    ))}
                                    <br/>
                                </div>
                            ))}

                        </div>
                        : null
            }
        </div>
    )
}

export default RequisitosCard